module.exports = __webpack_public_path__ + "public/images/defaultAvatarCompany.94c42bafcf2a13c5d1bb5c6b73fd30a5.svg";